import React, { useMemo } from "react";
import {
  Box,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material";
import MultiSelectField from "../../shared/MultiSelectField";
import { PAGE_TYPE_MASTER } from "../../../constants/suggestOptions";

const SuggestListFilter = ({
  pageTypes,
  onChangePageTypes,
  sort,
  onChangeSort,
}) => {
  // 対象画面 MultiSelectField用に { value, label } -> { id, name } へ変換
  const pageTypeOptions = useMemo(
    () => PAGE_TYPE_MASTER.map((o) => ({ id: o.value, name: o.label })),
    [],
  );

  const handleSortChange = (_event, next) => {
    if (!next) return;
    onChangeSort?.(next);
  };

  return (
    <Box
      sx={{
        mb: 3,
        display: "flex",
        alignItems: "flex-end",
        gap: 3,
      }}
    >
      {/* 対象画面フィルタ */}
      <Box sx={{ flex: 1 }}>
        <MultiSelectField
          label="対象画面"
          value={pageTypes}
          onChange={onChangePageTypes}
          options={pageTypeOptions}
          placeholder="対象画面を選択"
        />
      </Box>

      {/* 並び順（固定幅） */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 2,
          flexShrink: 0,
        }}
      >
        <Typography sx={{ fontSize: 13, fontWeight: 700 }}>並び順</Typography>

        <ToggleButtonGroup
          value={sort}
          exclusive
          onChange={handleSortChange}
          sx={{
            border: "1px solid",
            borderColor: "divider",
            borderRadius: 999,
            overflow: "hidden",
            "& .MuiToggleButtonGroup-grouped": {
              border: "none",
              px: 3,
              py: 1,
              fontWeight: 700,
              fontSize: 13,
            },
            "& .MuiToggleButton-root": {
              bgcolor: "grey.100",
            },
            "& .Mui-selected": {
              bgcolor: "common.white !important",
            },
          }}
        >
          <ToggleButton value="priority">優先度順</ToggleButton>
          <ToggleButton value="created_at">作成日順</ToggleButton>
        </ToggleButtonGroup>
      </Box>
    </Box>
  );
};

export default SuggestListFilter;
